<template>
	<div class="errors">
		<ul>
			<li :key="index" v-for="(error, index) in errors">{{ error }}</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'MErrors',
	props: {
		errors: {
			type: Array,
			default() {
				return [];
			}
		}
	}
}
</script>

<style scoped></style>
